<template>
  <div class="com-banner1">
    <div class="swiper-container swiper1">
      <div class="swiper-wrapper wrapper1">
        <div class="swiper-slide slide1"
             v-for="(item, index) in dataBanner" :key="index">
          <div class="dp-picture com-size-all">
            <img :src="stateimgBaseURL+item.imga_path" alt="" class="dp-img1 com-size-all com-object-fit-cover">
          </div>
          <div class="dp-word com-size-all com-position-absolute-start" v-if="item.name">
            <div class="dp-cntitle1">{{ item.name }}</div>
            <div class="dp-line1"><b></b></div>
            <div class="dp-entitle1">{{ item.recom }}</div>
          </div>
          <img :src="stateimgBaseURL+item.imgb_path" alt="" v-if="item.imgb_path"
               class="dp-backimg1 com-size-all com-position-absolute-start com-object-fit-cover">
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import {mapState} from 'vuex'

export default {
  data() {
    return {
      type: '',
      dataBanner: [],
      name: '',
      id: '',
    }
  },
  computed: {
    ...mapState(['stateimgBaseURL'])
  },
  created() {

    this.name = this.$route.name
    /*
     1-首页，2-用户中心，3-新闻中心，4-下载中心，5-品牌故事，6-荣誉资质，7-全球布局，
     8-品牌文化，10-发展历程，11-产品中心，12-招贤纳士，13-招商加盟，14-联系我们
   */
    /*
    1 首页 2 用户中心 3 新闻中心 4 下载中心 5 品牌故事 6 荣誉资质 7 全球布局
    8 品牌文化-顶部 9 品牌故事 10 发展历程 11 产品中心 12 招贤纳士 13 招商加盟
    14 联系我们 15 品牌文化-底部
 */
    if (this.name == 'home') {
      this.type = this.id = 1
    } else if (this.name == 'feedback' || this.name == 'policy' || this.name == 'network' || this.name == 'find' || this.name == 'distinguish' || this.name == 'guide') {
      this.type = this.id = 2
    } else if (this.name == 'news' || this.name == 'news_detail') {
      this.type = this.id = 3
    } else if (this.name == 'prodcatalogue' || this.name == 'proddata' || this.name == 'prodvideo') {
      this.type = this.id = 4
    } else if (this.name == 'introduce') {
      this.type = this.id = 5
    } else if (this.name == 'honor') {
      this.type = this.id = 6
    } else if (this.name == 'layout') {
      this.type = this.id = 7
    } else if (this.name == 'culture') {
      this.type = this.id = 8
    } else if (this.name == 'development') {
      this.type = this.id = 10
    } else if (this.name == 'product' || this.name == 'product_detail') {
      this.type = this.id = 11
    } else if (this.name == 'recruit') {
      this.type = this.id = 12
    } else if (this.name == 'join') {
      this.type = this.id = 13
    } else if (this.name == 'contact2') {
      this.type = this.id = 14
    }
    this.dataRequestbasis_getBanner()
    this.dataRequestindex_seo()
  },
  methods: {
    initSwiperHomeprod() {
      let mySwiperbanner1 = new Swiper('.com-banner1 .swiper1', {
        watchOverflow: true,
        autoHeight: true,
        pagination: {
          el: '.com-banner1 .swiper1 .swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    },
    // GET获取seo
    dataRequestindex_seo() {
      let params = {
        id: this.id,
      }
      this.$api.user.index_seo(params).then(res => {
        document.title = res.data.seo.title
        document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.seo.keywords);
        document.querySelector('meta[name="description"]').setAttribute('content', res.data.seo.description);
      })
    },
    // 获取banner图
    dataRequestbasis_getBanner() {
      let params = {
        type: this.type,
      }
      this.$api.user.basis_getBanner(params).then(res => {
        this.dataBanner = res.data.list

        this.$nextTick(() => {
          this.initSwiperHomeprod()
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.com-banner1 {
  .swiper1 {
    .slide1 {
      height: 320px;

      .dp-word {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 46px;
        padding: 0 210*$pc-conversion;

        .dp-cntitle1 {
          color: $color1;
        }

        .dp-line1 {
          width: 190px;
          height: 2px;
          background: $background1;
          margin: 20px 0 22px;

          b {
            width: 50%;
            height: 100%;
            display: block;
            background: $color1;
          }
        }

        .dp-entitle1 {
          color: #ffffff;
          font-weight: 600;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .com-banner1 {
    .swiper1 {
      .slide1 {
        height: 300*$mobile-conversion;

        .dp-word {
          font-size: 46*$mobile-conversion;
          padding: 0 50*$mobile-conversion;

          .dp-line1 {
            width: 190*$mobile-conversion;
            margin: 20*$mobile-conversion 0 22*$mobile-conversion;
          }
        }
      }
    }
  }
}
</style>
